module.exports = __webpack_public_path__ + "img/5.e8a2536b.png";